import { AnalyticsBrowser } from '@segment/analytics-next';

import { SEGMENT_WRITE_KEY } from '@frontend/envConfig';
import { OPAL_ANALYTICS_STORAGE_KEY } from '@frontend/utils/misc';

const getWriteKey = (): string => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const storedKey = localStorage.getItem(OPAL_ANALYTICS_STORAGE_KEY);
    if (storedKey) return storedKey;
  }
  return SEGMENT_WRITE_KEY || '';
};

let analyticsBrowser: AnalyticsBrowser | null = null;

export const getAnalyticsBrowser = (): AnalyticsBrowser | null => {
  if (!analyticsBrowser) {
    const writeKey = getWriteKey();
    if (writeKey) {
      analyticsBrowser = AnalyticsBrowser.load({ writeKey });
    }
  }
  return analyticsBrowser;
};
